import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
//import { LazyLoadImage } from 'react-lazy-load-image-component'

import SWAPGO_PC from 'assets/images/main_swapgo.png'
import SWAPGO_MOBILE from 'assets/images/main_swapgo_mobile.png'
import GENSTATION_MAIN_VIDEO from 'assets/video/getstation_main.mp4'
import IMG_4_1 from 'assets/images/evc1_samsung_sdi.png'
import IMG_4_1_1 from 'assets/images/SamsungSDI1024.png'
import IMG_4_1_1_T from 'assets/images/SamsungSDI640.png'
import IMG_4_2 from 'assets/images/top_right.png'
import IMG_5_1 from 'assets/images/genstation_main.png'
import IMG_6_1 from 'assets/images/gogoro_app.png'
import IMG_6_2 from 'assets/images/gogoro_smart_battery.png'
import IMG_8_1 from 'assets/images/we_are_gogoro.png'

import IMG_2_1 from 'assets/images/find_go_station.png'
import IMG_3_1 from 'assets/images/gogoro_motors.png'
import IMG_7_1 from 'assets/images/gogoro_move_on.png'

import { OUTER_URL, URL, COMPANY_NAME_KO, COMPANY_NAME_EN } from '../../utils/Utils'
import { getCookie, setCookie } from '../../utils/UtilsStorage'
import './HomeMain.scss'
import '../../style/pretendard.scss'
import axios from 'axios'
import { Autoplay, Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/pagination'
/**
 * @file 홈페이지 main 화면
 */
function HomeMain() {
    let navigate = useNavigate()

    // 사용자의 화면 너비
    const [width, setWidth] = useState(window.innerWidth)
    // 모바일 여부
    const [isMobile, setMobile] = useState()
    // 화면 너비에 따른 모바일 유무 확인
    useEffect(() => {
        width >= 1024 ? setMobile(false) : setMobile(true)
    }, [width])

    useEffect(() => {
        // 윈도우 헤더 사이즈 생성
        const height = window.innerHeight
        const width = window.innerWidth

        // 헤더 사이즈에 따른 동영상 크키 변환
        let headerSize = width > 1120 ? 72 : width > 768 ? 89 : 69

        // 초기 페이지 오픈 시, 비디오 태그 접근
        const mainTop = document.getElementsByClassName('main-top')[0]
        mainTop.style.height = `${height - headerSize}px`

        // 브라우저 리사이징 함수
        window.onresize = function () {
            const height = window.innerHeight
            mainTop.style.height = `${height - headerSize}px`
        }

        const handleResize = () => {
            setWidth(window.innerWidth)
        }

        window.addEventListener('resize', handleResize)

        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    const [isPopupShow, setIsPopupShow] = useState({})
    const [isSlidePopupShow, setIsSlidePopupShow] = useState(false)

    const [mainPopup, setMainPopup] = useState() //
    const [slidePopup, setSlidePopup] = useState() //

    //팝업데이터 조회 후 초기화
    useEffect(() => {
        if (!mainPopup?.length) return
        const popupState = {}
        mainPopup.forEach(item => {
            const cookie = getCookie(`popup_show_${item.serial_number}`)
            popupState[item.serial_number] = cookie !== false
        })

        setIsPopupShow(popupState)
    }, [mainPopup])

    useEffect(() => {
        if (!slidePopup?.length) return

        const cookie = getCookie(`slide_popup_show`)

        setIsSlidePopupShow(cookie !== false)
    }, [slidePopup])

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_BB_URL}/api/display/content/list/active`, {
                params: {
                    content_type: 'PP', //콘텐츠유형 (PP:팝업 / BN:배너)
                    display_type: 'NP', //콘텐츠 노출 유형 (SP:슬라이드팝업 / NP:단독팝업 / TB:상단배너 / BB:하단배너)
                    service_code: 'DH', //플랫폼구분 (GM:고고로몰, BH:BB홈페이지)
                    display_device_code: '', //
                },
            })
            .then(res => {
                if (res?.data?.code === '00') {
                    setMainPopup(res?.data?.data)
                }
            })
            .catch(error => {})

        axios
            .get(`${process.env.REACT_APP_BB_URL}/api/display/content/list/active`, {
                params: {
                    content_type: 'PP',
                    display_type: 'SP',
                    service_code: 'DH',
                    display_device_code: '',
                },
            })

            .then(res => {
                if (res?.data?.code === '00') {
                    const sortedData = [...res.data.data].sort((a, b) => a.priority - b.priority)

                    setSlidePopup(sortedData)
                }
            })

            .catch(error => {})
    }, [])

    // 팝업창닫기
    const closePopup = serialNumber => {
        setIsPopupShow(prev => ({
            ...prev,

            [serialNumber]: false,
        }))
    }

    // 오늘하루보지않기
    const todayStopBtn = serialNumber => {
        const date = new Date()
        const expires = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59)
        setCookie(`popup_show_${serialNumber}`, false, { expires })
        setIsPopupShow(prev => ({
            ...prev,
            [serialNumber]: false,
        }))
    }

    const todayStopSlidePopup = () => {
        const date = new Date()
        const expires = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59)
        setCookie('slide_popup_show', false, { expires })

        setIsSlidePopupShow(false)
    }

    return (
        <>
            {mainPopup
                ?.filter((v, i) => !!v.image_url)
                ?.map(
                    (val, idx) =>
                        isPopupShow[val?.serial_number] && (
                            <div
                                className={`main-popup-wrap ${
                                    isMobile
                                        ? ['ALL', 'MOBILE'].includes(val?.display_device_code)
                                            ? ''
                                            : 'hidden'
                                        : ['ALL', 'PC'].includes(val?.display_device_code)
                                          ? ''
                                          : 'hidden'
                                }`}
                                style={{
                                    zIndex: 999999 - val?.priority,
                                }}>
                                <img src={val?.image_url} alt="메인팝업" className="main-popup-img" />

                                <div className="popup-btn-box">
                                    {!!val?.link_url ? (
                                        <button
                                            className="popup-btn"
                                            onClick={() => {
                                                if (val?.link_target === 'BLANK') {
                                                    window.open(val?.link_url, '_blank')
                                                } else {
                                                    window.open(val?.link_url, '_self')
                                                }
                                            }}>
                                            문의하기
                                        </button>
                                    ) : (
                                        <button className="popup-btn" onClick={() => todayStopBtn(val.serial_number)}>
                                            오늘 그만 보기
                                        </button>
                                    )}

                                    <button className="popup-btn" onClick={() => closePopup(val.serial_number)}>
                                        닫기
                                    </button>
                                </div>
                            </div>
                        ),
                )}

            {/* 슬라이드팝업 */}
            {isSlidePopupShow && (
                <div className="main-slide-popup-wrap">
                    <Swiper
                        loop
                        slidesPerView={1}
                        autoHeight
                        pagination={{
                            clickable: true,
                        }}
                        modules={[Autoplay, Pagination]}
                        autoplay={{
                            delay: 30000,
                            disableOnInteraction: false,
                        }}>
                        {slidePopup
                            ?.filter(v => {
                                if (!v.image_url) return false

                                return isMobile
                                    ? ['ALL', 'MOBILE'].includes(v?.display_device_code)
                                    : ['ALL', 'PC'].includes(v?.display_device_code)
                            })
                            ?.map(val => (
                                <SwiperSlide key={val.serial_number}>
                                    <img
                                        className="main-slide-popup-img"
                                        src={val.image_url}
                                        alt="슬라이드팝업"
                                        onClick={() => {
                                            if (val?.link_target === 'BLANK') {
                                                window.open(val?.link_url, '_blank')
                                            } else if (val?.link_target === 'SELF') {
                                                window.open(val?.link_url, '_self')
                                            }
                                        }}
                                    />
                                </SwiperSlide>
                            ))}
                    </Swiper>

                    <div className="popup-btn-box">
                        <button className="popup-btn" onClick={todayStopSlidePopup}>
                            오늘 그만 보기
                        </button>

                        <button className="popup-btn" onClick={() => setIsSlidePopupShow(false)}>
                            닫기
                        </button>
                    </div>
                </div>
            )}

            <div className="main-top">
                <div className="top-text-box">
                    <div className="t1 title">언제나 어디서나 쉽고 빠르게</div>
                    <img className="swapgo pc" src={SWAPGO_PC} alt="swap & go" />
                    <img className="swapgo mobile" src={SWAPGO_MOBILE} alt="swap & go" />
                    <div className="t1 sub-title">충전보다 빠른 배터리 교환 시스템</div>
                </div>

                {/* <swyun_221229> 아이폰에서는 playsinline 라인을 처리해야함 */}
                <video
                    className="video-box"
                    src={GENSTATION_MAIN_VIDEO}
                    type="video/mp4"
                    autoPlay
                    muted
                    loop
                    playsInline
                    fullscreen="true"></video>
            </div>

            <div className="main-two">
                <div className="main-two" style={{ backgroundImage: `url(${IMG_2_1})` }}>
                    <div>
                        <div className="text-box">
                            <div className="t1">혁신적인 배터리 네트워크</div>
                            <div className="sub">
                                몇 초 안에 충전되는 배터리 교환 시스템으로 <br className="break-m" /> 새로운 주행을
                                경험하세요.
                            </div>
                            <a className="link" href={URL.NETWORK.MAIN}>
                                스왑스테이션 지도 보기 {'>'}
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div
                className="main-three"
                style={{
                    backgroundImage: `url(${IMG_3_1})`,
                }}
                onClick={() => {
                    navigate(URL.SCOOTER.MAIN)
                }}>
                <div>
                    <div className="text-box">
                        <div className="t1">Gogoro 스마트 전기 스쿠터</div>
                        <div className="sub">똑똑하게 즐기는 새로운 주행 경험</div>
                        <a className="link" href={URL.SCOOTER.MAIN}>
                            더 알아보기 {'>'}
                        </a>
                    </div>
                </div>
            </div>

            <div className="main-four">
                <div>
                    <img src={IMG_4_1} alt="2025 interbattery" />
                    <div className="text-box">
                        <div className="sub">2025 인터배터리</div>
                        {width > 1120 ? (
                            <img
                                src={IMG_4_1_1}
                                className="img_4_1_text"
                                alt=""
                                style={{ width: '100%', marginTop: '20px', marginBottom: '8px' }}
                            />
                        ) : width > 768 ? (
                            <img
                                src={IMG_4_1_1_T}
                                className="img_4_1_text"
                                alt=""
                                style={{ width: '100%', maxWidth: '640px', marginTop: '24px', marginBottom: '8px' }}
                            />
                        ) : (
                            <img
                                src={IMG_4_1_1_T}
                                className="img_4_1_text"
                                alt=""
                                style={{ width: '100%', maxWidth: '640px', marginTop: '12px', marginBottom: '8px' }}
                            />
                        )}
                    </div>
                </div>
                <a href={URL.NETWORK.MAIN}>
                    <img src={IMG_4_2} alt="battery replacement" />
                    <div className="text-box">
                        <div className="sub">지속 가능한 에너지</div>
                        <div className="t1">
                            Gogoro Network <br className="break-m" style={{ display: 'inline' }} /> 배터리 교환 서비스
                        </div>
                    </div>
                </a>
            </div>

            <div className="main-five">
                <div>
                    <img src={IMG_5_1} alt="world infrastructure" />
                    <div className="text-box">
                        <div className="sub">Gogoro Network 국내 공식 파트너</div>
                        <div className="t1">에너지 플랫폼 {COMPANY_NAME_KO}</div>
                        <div className="des">
                            세계 최대 인프라를 가진 Gogoro Network를
                            <br />
                            닷스테이션이 독점계약하여
                            <br />
                            국내에도 에너지 플랫폼을 구축합니다.
                        </div>
                    </div>
                </div>
            </div>

            <div className="main-six">
                <div className="gogoro">
                    <img src={IMG_6_1} alt="gogoro app" />
                    <div className="text-box">
                        <div className="t1">주행을 더 똑똑하게</div>
                        <div className="sub">
                            차량의 정보부터 스왑 스테이션의 이용 내역까지
                            <br />
                            스마트한 기능으로 편리한 라이딩을 즐겨보세요.
                        </div>
                    </div>
                </div>
                <div>
                    <img src={IMG_6_2} alt="network product" />
                    <div className="text-box">
                        <div className="t1">{COMPANY_NAME_EN}</div>
                        <div className="sub">
                            보다 빠르게, 편리하게, 스마트하게
                            <br />
                            SWAP & GO
                        </div>
                    </div>
                </div>
            </div>

            <div
                className="main-seven"
                style={{ backgroundImage: `url(${IMG_7_1})` }}
                /* onClick={() => (window.location.href = OUTER_URL.YOUTUBE_BATTERY_CHANGE)} */
            >
                <div>
                    <div className="text-display">
                        <div className="t1">
                            새로운 경험
                            <br />
                            SWAP &amp; GO
                        </div>
                        <a
                            className="link"
                            href={OUTER_URL.YOUTUBE_BATTERY_CHANGE}
                            target="_blank"
                            rel="noopener noreferrer">
                            비디오 보기 &gt;
                        </a>
                    </div>
                </div>
            </div>

            <div className="main-eight">
                <div>
                    <div className="box-header">
                        <div className="t1">
                            {COMPANY_NAME_EN}이 만드는
                            <br className="break-m" style={{ display: 'inline' }} /> 친환경 에너지 플랫폼
                        </div>
                    </div>
                    <img src={IMG_8_1} alt="gogoro network" />
                    <div className="three-flex">
                        <div>
                            <div className="t1">미래를 위한 솔루션</div>
                            <div className="sub">
                                뛰어난 기술력과 스마트 혁신으로
                                <br />더 편리한 미래를 만들어 나갑니다.
                            </div>
                        </div>
                        <div>
                            <div className="t1">보다 빠르게, 편리하게, 스마트하게</div>
                            <div className="sub">
                                우리는 더 나은 세상을 만들기 위해
                                <br />
                                최적의 친환경 에너지 솔루션을 제시합니다.
                            </div>
                        </div>
                        <div>
                            <div className="t1">내일을 위한 에너지</div>
                            <div className="sub">
                                스마트한 에너지 플랫폼은 모두가 행복한 미래, <br />
                                지속가능한 세상을 만들기 위한 노력입니다.
                            </div>
                        </div>
                    </div>
                    <a className="link" href={OUTER_URL.GOGORO_HOME} target="_blank" rel="noopener noreferrer">
                        Gogoro 소개
                    </a>
                </div>
            </div>
        </>
    )
}

export default HomeMain
